import React from 'react';

const authModelContext = React.createContext();

export default authModelContext;
